import { type SingleSelectedValueFilter } from 'components/brokers/types'

const EnrollmentIdFilter = ({
  selectedValue,
  selectValue,
}: SingleSelectedValueFilter) => {
  return (
    <input
      type='text'
      placeholder='Enter enrollment ID'
      value={selectedValue || ''}
      onChange={(e) => selectValue(e.target.value)}
      className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
    />
  )
}

export default EnrollmentIdFilter
